"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_portals__for__videos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "72e52014-6a1d-4b6b-bb80-376e91755a02",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "portals-for-videos-mid"), /*#__PURE__*/React.createElement("g", {
    id: "4f090bd8-c7f2-42be-b4cf-434aaa7bf63d",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "df8982ef-b45c-487a-b56a-305b21a5af9f",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("line", {
    id: "a0fe603c-307d-4e75-88ee-3d1f8be193f1",
    "data-name": "<Path>",
    x1: 56,
    y1: 158,
    x2: 136,
    y2: 158,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 158,
    x2: 96,
    y2: 142,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 42,
    width: 156,
    height: 100,
    rx: 14,
    ry: 14,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.31,91.11,87.46,81.77a1,1,0,0,0-1.46.89v18.69a1,1,0,0,0,1.46.89l17.84-9.35A1,1,0,0,0,105.31,91.11Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })));
}

var _default = ic_portals__for__videos;
exports.default = _default;